import React from 'react'
import Slider from 'react-slick'
import styles from './ComponentHostingPlans.scss'
import {useSliderHook} from '../../common/hooks/useSliderHook'
import ComponentSharedHostingBlock2022
	from '../ComponentSharedHostingBlock2022/ComponentSharedHostingBlock2022'
import Button, {buttons} from '../../common/primitives/Button';
import {_scrollTo} from '../../common/helpers/HelperAnimation';

import PropTypes from 'prop-types'
import RenderIf from '../../common/primitives/RenderIf/RenderIf'
import {__t} from '../../common/lang/text-resource'

const ComponentHostingPlans = (props) => {
	const {sliderRef, sliderInitialized, animationComplete, settings} =
	  useSliderHook('js-hosting-plans', 'js-hosting-plans-container', 500, false, false, props.hostingPromo)

	const isMobile = window.innerWidth < 500;

	const getplans = () => [
		<ComponentSharedHostingBlock2022
		  actionContinue={props.actionContinue}
		  addSSToCart={props.addSSToCart}
		  addToCart={props.addToCart}
		  isWP={props.isWP}
		  showPriceSelector={props.showPriceSelector}
		  selectedTermInit={12}
		  hostingPromo={props.hostingPromo}
		  key={props.hostingPromo ? 'plan_03' : 'plan_01'}
		  planId={props.hostingPromo ? 'plan_03' : 'plan_01'}
		/>,
		<ComponentSharedHostingBlock2022
		  actionContinue={props.actionContinue}
		  addToCart={props.addToCart}
		  isWP={props.isWP}
		  showPriceSelector={props.showPriceSelector}
		  selectedTermInit={12}
		  hostingPromo={props.hostingPromo}
		  isRecommended={!props.hostingPromo}
		  key={'plan_02'}
		  planId={'plan_02'}
		/>,
		<ComponentSharedHostingBlock2022
		  actionContinue={props.actionContinue}
		  addToCart={props.addToCart}
		  isWP={props.isWP}
		  showPriceSelector={props.showPriceSelector}
		  selectedTermInit={12}
		  hostingPromo={props.hostingPromo}
		  key={props.hostingPromo ? 'plan_01' : 'plan_03'}
		  planId={props.hostingPromo ? 'plan_01' : 'plan_03'}
		/>,
	]

	const getSlider = () => {
		return (
		  <Slider {...settings} ref={sliderRef}>
			  {getplans()}
		  </Slider>
		)
	}

	const scrollToFeatures = () => {
		_scrollTo(
		  document.querySelector(`.js-features-table-container`),
		  -200,
		  500,
		  'easeOutQuad'
		);

	}

	if (
	  sliderInitialized &&
	  isMobile &&
	  sliderRef &&
	  sliderRef.current &&
	  !animationComplete
	) {
		sliderRef.current.slickGoTo(1, true)
	}

	return (
	  <>
		  <div
			id='js-hosting-plans-container'
			className={styles.plansContainerOuter}
		  >
			  <div id={'js-hosting-plans'} className={styles.plansContainer}>
				  {isMobile ? getSlider() : getplans()}
			  </div>
		  </div>
		  <RenderIf condition={typeof props.children !== 'undefined'}>
			  {props.children}
		  </RenderIf>
		  <RenderIf condition={typeof props.children === 'undefined'}>
			  {props.hostingPromo === true ?
				<div className={styles.ps}>
					{props.endOfMonthDate ?
					  <>
						  {__t('* Промоцията е валидна до :endOfMonthDateг.', {endOfMonthDate: props.endOfMonthDate})}
						  <br/>
					  </> : ''}
					{__t('-посочените-цени-са-валидни-при-покупка-на-нов-хо688ef8')}
					<br/>
					{__t('**Източник на данните: НСИ')}
				</div>
				:
				<div className={styles.ps}>
					{__t('-посочените-цени-са-валидни-при-покупка-на-нов-хоdc9a35')}&nbsp;
					<Button value={__t('сравнителната таблица')} onClick={scrollToFeatures}
							className={`${buttons.buttonLink} ${buttons.action}`}/>
					&nbsp;{__t('по-долу. Цените са с включен ДДС.')}
				</div>
			  }
		  </RenderIf>
	  </>
	)
}

ComponentHostingPlans.defaultProps = {
	addSSToCart: null,
	isWP: false,
	showPriceSelector: true,
	addToCart: null,
	hostingPromo: false
}

ComponentHostingPlans.propTypes = {
	actionContinue: PropTypes.func,
	addSSToCart: PropTypes.func,
	isWP: PropTypes.bool,
	showPriceSelector: PropTypes.bool,
	hostingPromo: PropTypes.bool,
	children: PropTypes.node,
	addToCart: PropTypes.func
}

export default ComponentHostingPlans